module.exports = __webpack_public_path__ + "static/assets/e1ade8093535880ae5f26fc67c4b6306.svg";